import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Mail, Check } from "lucide-react";

const EmailConfirmed = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const email = searchParams.get("email");

  useEffect(() => {
    // Auto-navigate to login after 5 seconds
    const timer = setTimeout(() => {
      navigate("/login");
    }, 5000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-blue-50 to-purple-50 p-4">
      <div className="w-[400px] max-w-full bg-white rounded-2xl shadow-xl overflow-hidden">
        <div className="p-6 flex flex-col items-center justify-center">
          <div className="h-12 w-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <Check className="h-6 w-6 text-green-600" />
          </div>
          <h2 className="text-2xl font-semibold text-center text-green-600 mb-4">
            Email Confirmed!
          </h2>
          {email && (
            <p className="text-gray-500 text-center mb-2">
              <Mail className="inline-block h-4 w-4 mr-1" />
              {email}
            </p>
          )}
          <p className="text-gray-500 text-center mb-6">
            Your email has been confirmed successfully. You can now log in to
            your account.
          </p>
          <Button onClick={() => navigate("/login")} className="w-full">
            Go to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmed;
